import { render, staticRenderFns } from "./preflightPdfViewer.vue?vue&type=template&id=32b632d6&scoped=true&"
import script from "./preflightPdfViewer.vue?vue&type=script&lang=js&"
export * from "./preflightPdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./preflightPdfViewer.vue?vue&type=style&index=0&id=32b632d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b632d6",
  null
  
)

export default component.exports